// extracted by mini-css-extract-plugin
export var button = "footer-module--button--04452";
export var buttonsContainer = "footer-module--buttonsContainer--3586d";
export var legalLinks = "footer-module--legalLinks--cfca5";
export var logo = "footer-module--logo--4822d";
export var wrapper = "footer-module--wrapper--0877b";